import { jsx as _jsx } from "react/jsx-runtime";
/**
 * @primitive SkeletonText (server)
 * ROLE: none — aria-hidden="true" on each line; purely decorative
 * KEYBOARD: non-focusable
 * FOCUS: none
 * LIVE-REGION: none — wrap in <SkeletonGroup> for SR announcement
 * PRM: shimmer disabled; solid var(--muted) per Skeleton PRM rule
 * FORCED-COLORS: inherits Skeleton forced-colors rule
 * RTL: direction-agnostic (last-line narrowing reads naturally in both directions)
 * RSC: SERVER
 *
 * Line metrics match Body size variants so skeleton proportions remain accurate
 * when placed alongside live body text:
 *   lg → height=20px (var(--type-body-lg-size)=1rem → 16px × line-height≈1.25 step)
 *   md → height=16px
 *   sm → height=13px
 */
import { Skeleton } from '../Skeleton/Skeleton';
import { Stack } from '../../layout/Stack/index';
// Height per size matches Body metrics (approximated to whole px for skeleton clarity).
const HEIGHT = { lg: 20, md: 16, sm: 13 };
// Gap between lines mirrors body line-height rhythm.
const GAP = {
    lg: 'md',
    md: 'sm',
    sm: 'sm',
};
export function SkeletonText({ lines = 3, size = 'md', className }) {
    const h = HEIGHT[size];
    const gap = GAP[size];
    return (_jsx(Stack, { className: className, gap: gap, children: Array.from({ length: lines }, (_, i) => {
            // Narrow the last line to ~75% to mimic natural paragraph end.
            const width = i === lines - 1 && lines > 1 ? '75%' : '100%';
            return _jsx(Skeleton, { width: width, height: h, rounded: "sm" }, i);
        }) }));
}
//# sourceMappingURL=SkeletonText.js.map